import { VizState } from '@cubejs-client/react';
import { Chart } from '@threatadvisor/react-components';
import { Typography } from 'antd';
import React, { ReactElement, useState } from 'react';

type StatusReportParams = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
  securityEventApi: string;
};

export default function EventsByTactic(props: StatusReportParams): ReactElement {
  const { clientUid, reportStart, reportEnd, securityEventApi } = props;

  const chartConfig: VizState = {
    chartType: 'bar',
    pivotConfig: {
      x: ['security_event_mapping.tactic'],
      y: ['measures'],
      fillMissingDates: true
      //joinDateRange: false
    },
    query: {
      measures: ['security_event.count'],
      order: {
        'security_event.count': 'desc'
      },
      dimensions: ['security_event_mapping.tactic'],
      timeDimensions: [
        {
          dimension: 'security_event.createdDate',
          dateRange: [reportStart, reportEnd]
        }
      ],
      filters: [
        {
          member: 'security_event.clientUid',
          operator: 'equals',
          values: [clientUid]
        }
      ],
      limit: 15
    }
  };

  return (
    <>
      <h2 className="text-uppercase">Events by Tactic</h2>
      <figure>
        {' '}
        <Chart
          hideCubeName={false}
          useGridTable
          useHeightBasedOnHowManyItems
          wrapCategoryAxisLabel
          chartConfig={{
            legend: false,
            label: {
              // AT EACH Y POINT
              position: val => {
                console.log(val);
              },
              style: {
                becomeWrap: true,
                wordWrapWidth: 40,
                wordWrap: true
              }
            }
          }}
          config={chartConfig}
        />
        <figcaption>
          <Typography.Text type="secondary">
            Shows MITRE ATT&CK Tactic associated with events received. See Appendix A for additional
            information.
          </Typography.Text>
        </figcaption>
      </figure>
    </>
  );
}
